import { TDotsProps } from '../type';
import { DotsWrapper } from './styles';
import { ReactComponent as DotsVertical } from 'components/icons/dots-vertical.svg';

export const ActionDots = ({ fullWidth, style, onClick }: TDotsProps) => (
  <DotsWrapper fullWidth={fullWidth} style={style} onClick={onClick}>
    <DotsVertical className="more-dots" />
  </DotsWrapper>
);
